// extracted by mini-css-extract-plugin
export default {"wrapper":"case_wrapper__h9Skg","title":"case_title__ja-kk","pannel":"case_pannel__ngEec","img_box":"case_img_box__toQOq","content":"case_content__m-AAI"};